module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "space"
  }), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_vm._v("Copyright © Seaforth Publishing 2012")])]), _c('a', {
    attrs: {
      "id": "Copyright"
    }
  }, [_c('p', {
    staticClass: "copyright3"
  }, [_vm._v("First published in Great Britain in 2012 by Seaforth Publishing,"), _c('br'), _vm._v("\nan imprint of Pen & Sword Books Ltd, 47 Church Street, Barnsley,"), _c('br'), _vm._v("\nS Yorkshire S70 2AS")])]), _c('p', {
    staticClass: "copyright3"
  }, [_c('a', {
    attrs: {
      "id": "Copyright"
    }
  }), _c('a', {
    attrs: {
      "href": "http://www.seaforthpublishing.com",
      "target": "_blank"
    }
  }, [_vm._v("www.seaforthpublishing.com")])]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("British Library Cataloguing in Publication Data"), _c('br'), _vm._v("\nA CIP data record for this title is available from the British Library")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("ISBN 978-1-84832-152-6"), _c('br'), _vm._v("\nPDF ISBN: 978-1-78346-571-2"), _c('br'), _vm._v("\nEPUB ISBN: 978-1-78383-037-4"), _c('br'), _vm._v("\nPRC ISBN: 978-1-78346-804-1")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("All rights reserved. No part of this publication may be reproduced"), _c('br'), _vm._v("\nor transmitted in any form or by any means, electronic or"), _c('br'), _vm._v("\nmechanical, including photocopying, recording, or any"), _c('br'), _vm._v("\ninformation storage and retrieval system, without either prior"), _c('br'), _vm._v("\npermission in writing from the publisher or a licence permitting"), _c('br'), _vm._v("\nrestricted copying.")]), _vm._v(" "), _c('p', {
    staticClass: "copyright3"
  }, [_vm._v("Typeset and designed by Stephen Dent"), _c('br'), _vm._v("\nPrinted and bound in China")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f8513ec","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/04_Copyright.vue
// module id = 63
// module chunks = 0